var chunkToChildrenMap = {
	"16368": [
		45324,
		40349,
		47575,
		87,
		5783,
		88636,
		20794,
		60822,
		82591,
		19867,
		41795,
		45062,
		49653,
		74837,
		62087,
		82631,
		95682,
		12044,
		95067,
		91460,
		81796,
		578,
		51672
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));